
export default {
  mounted  (el, ops) {
    el.addEventListener('mouseenter', (e) => {
      e.stopPropagation()
      inModule(ops.value)
    }, { passive: true })
  }
}
